import { Genrelist } from "../../Model/Content";
import React from "react";

import {
  SVGIcons,
  ImgIcons,
  withRouter,
} from "../../Helpers/Common";
import {
  Link, NavLink,
} from "react-router-dom";
import BarLoader from "react-spinners/BarLoader";
var SVGIcon = "";
SVGIcons().then((resultData) => (SVGIcon = resultData));

class Allbays extends React.Component {

  constructor(props) {

    super(props);
    this.state = {
      Genrelistdata: false
    };
  }

  componentDidMount() {

    this.setState({ Genrelistdata: this.props.baydata })

  }

  render() {

    if (this.state.Genrelistdata == false) {
      // return <div className="loader"></div>;
      return <div className="loader"><BarLoader color="#ff000f" /></div>;
    }

    return (
      <>
        <div className="allBaypopup dD-none" id="passChange">
          <button className="temp54-modal-close temp54-modal-toggle">
            <img src={SVGIcon["allBays-close.svg"]} onClick={() => { this.props.functions.ShowallbaysClose(); }} alt="Docubay" />
          </button>
          <div className="temp54-modal-body dD-none">
            <div className="temp54-awesome">
              <ul>
                {this.state.Genrelistdata?.map((data, index) => {
                  return (
                    <li key={index}>
                      <a href={"/baypage/" + data.name.toLowerCase()} onClick={() => { this.props.functions.ShowallbaysClose(); }} >
                        {data.name}<span>{data.suffix}</span>
                      </a>
                    </li>
                  )
                })}
              </ul>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(Allbays);
